const local = {
  "server-host": "http://localhost:5000",
  "client-host": "http://localhost:3000",
};

const preprod = {
  "server-host": "http://192.168.1.8:8091",
  "client-host": "http://192.168.1.8:8092",
};

const watest = {
  "server-host": "https://watest.heartgenetics.com/backend",
  "client-host": "https://watest.heartgenetics.com",
};

const prod = {
  "server-host": "https://genetik.invenimus.ch/backend",
  "client-host": "https://genetik.invenimus.ch",
  "matomo-host": "https://statistics.heartgenetics.com/",
  "site-id": 4,
};

const config = function () {
  switch (process.env.REACT_APP_ENV) {
    case "local":
      return local;
    case "preprod":
      return preprod;
    case "watest":
      return watest;
    case "prod":
      return prod;
    default:
      return local;
  }
};

export default config();
